<template>
  <hm-content title="">
    <div class="table-panel flex  flex-end">
      <el-input
        clearable
        style="width: 200px"
        v-model.trim="searchCondition.keyword"
        placeholder="请输入姓名/电话"
        size="small"
        class="ipt mr20"
      ></el-input>
      <!-- <el-cascader
        v-model="searchCondition.wxshopCategoryId"
        :show-all-levels="false"
        size="small"
        class="mr10"
        :props="categoryFunc"
        clearable
        placeholder="请选择微店商品分类"
      ></el-cascader>
      <el-cascader
        v-model="searchCondition.attributeId"
        placeholder="请选择辅助属性"
        :show-all-levels="false"
        size="small"
        class="mr10"
        :props="attributeFunc"
        clearable
      ></el-cascader> -->
      <el-date-picker
        :default-time="['00:00:00', '23:59:59']"
        class="mr10"
        size="small"
        value-format="yyyy-MM-dd HH:mm:ss"
        v-model="searchCondition.date"
        type="datetimerange"
        range-separator="至"
        start-placeholder="选择分销时间段"
        end-placeholder="选择分销时间段"
      ></el-date-picker>
      <!-- <el-input
        clearable
        style="width: 120px"
        v-model.trim="searchCondition.minTotalMoneyProfitAmount"
        placeholder="总计佣金下限"
        size="small"
        class="ipt mr10"
      ></el-input>
      <el-input
        clearable
        style="width: 120px;"
        v-model.trim="searchCondition.maxTotalMoneyProfitAmount"
        placeholder="总计佣金上限"
        size="small"
        class="ipt mr20"
      ></el-input>

      <el-input
        clearable
        style="width: 130px"
        v-model.trim="searchCondition.minTotalSalesVolume"
        placeholder="分销成交额下限"
        size="small"
        class="ipt mr10"
      ></el-input> -->
      <!-- <el-input
        clearable
        style="width: 130px"
        v-model.trim="searchCondition.maxTotalSalesVolume"
        placeholder="分销成交额上限"
        size="small"
        class="ipt mr20"
      ></el-input>

      <el-input
        clearable
        style="width: 130px"
        v-model.trim="searchCondition.minShareOrderNum"
        placeholder="分销订单数下限"
        size="small"
        class="ipt mr10"
      ></el-input> -->
      <!-- <el-input
        clearable
        style="width: 130px"
        v-model.trim="searchCondition.maxShareOrderNum"
        placeholder="分销订单数上限"
        size="small"
        class="ipt mr10"
      ></el-input> -->

      <el-button type="primary" size="small" @click="search">查询</el-button>
      <el-button type="info" size="small" @click="searchCondition = {}"
        >重置</el-button
      >
    </div>

    <div class="table">
      <el-table
        @sort-change="sortChange"
        stripe
        border
        @selection-change="getChecked"
        ref="brandTable"
        :data="distributionBillList.records"
        style="width: 100%"
        id="table"
        size="small"
      >
        <!-- <el-table-column type="selection"></el-table-column> -->
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="joinTime"
          label="加入时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberName"
          label="姓名"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberMobile"
          label="电话"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="receiveAccount"
          label="收款账户"
        >
          <template slot-scope="scope">
            <div v-for="(v, i) in scope.row.accountInfoVoList" :key="i">
              <div v-if="v.receiveMode === 'wxpay'">
                微信:{{ v.receiveAccount }}
              </div>
              <div v-if="v.receiveMode === 'alipay'">
                支付宝:{{ v.receiveAccount }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="shareOrderNum"
          header-align="center"
          align="center"
          label="分销成单数"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="totalSalesVolume"
          label="分销成交额"
        >
          <template slot-scope="scope">
            <span>¥{{ scope.row.totalSalesVolume }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shareMemberNum"
          label="推荐会员数"
        >
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="totalPointProfitAmount"
          label="累计返积分"
          v-if="commType === 'point'"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="unlockPointAmount"
          label="锁定积分"
          v-if="commType === 'point'"
        >
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="totalMoneyProfitAmount"
          label="累计返货币"
          v-if="commType === 'money'"
        >
          <template slot-scope="scope">
            <span class="primary">¥{{ scope.row.totalMoneyProfitAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="hasGetcashMoneyAmount"
          label="已提现货币"
          v-if="commType === 'money'"
        >
          <template slot-scope="scope">
            <span class="success">¥{{ scope.row.hasGetcashMoneyAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="allowGetcashMoneyAmount"
          label="可提现货币"
          v-if="commType === 'money'"
        >
          <template slot-scope="scope">
            <span>¥{{ scope.row.allowGetcashMoneyAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="unlockMoneyAmount"
          label="锁定货币"
          v-if="commType === 'money'"
        >
          <template slot-scope="scope">
            <span>¥{{ scope.row.unlockMoneyAmount }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip class="item" content="佣金详情" placement="top">
                <button
                  class="pointer mr10 no-bg"
                  @click="toDetails(scope.row)"
                >
                  <span class="hmicon icon-yongjinxiangqing blue"></span>
                </button>
              </el-tooltip>
              <el-tooltip
                class="item"
                content="提现详情"
                placement="top"
                v-if="commType === 'money'"
              >
                <button class="pointer mr10 no-bg" @click="edit(scope.row)">
                  <span class="hmicon icon-tixianxiangqing blue"></span>
                </button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="distributionBillList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
        :page-size="pageSize"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="佣金详情"
      style="70%"
      :visible.sync="dialogVisible"
    >
      <div class="content">
        <ul class="info-list">
          <li class="mb20">
            <div class="mb20">
              <el-table stripe border :data="[detailsBill]" size="small">
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="memberName"
                  label="姓名"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="memberMobile"
                  label="电话"
                >
                </el-table-column>

                <!-- <el-table-column
                  header-align="center"
                  align="center"
                  prop="totalMoneyProfitAmount"
                  label="总计佣金"
                >
                  <template slot-scope="scope">
                    <div v-if="scope.row.totalMoneyProfitAmount">
                      ¥{{ scope.row.totalMoneyProfitAmount }}
                    </div>
                    <div v-if="scope.row.totalPointProfitAmount">
                      {{ scope.row.totalPointProfitAmount }}积分
                    </div>
                  </template>
                </el-table-column> -->
                <!-- <el-table-column
                  header-align="center"
                  align="center"
                  prop="hasGetcashMoneyAmount"
                  label="已提现佣金"
                >
                  <template slot-scope="scope">
                    <div class="primary" v-if="scope.row.hasGetcashMoneyAmount">
                      ¥{{ scope.row.hasGetcashMoneyAmount }}
                    </div>
                    <div class="primary" v-if="scope.row.hasGetcashPointAmount">
                      {{ scope.row.hasGetcashPointAmount }}积分
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="unlockMoneyAmount"
                  label="冻结佣金"
                >
                  <template slot-scope="scope">
                    <div class="danger" v-if="scope.row.unlockMoneyAmount">
                      ¥{{ scope.row.unlockMoneyAmount }}
                    </div>
                    <div class="danger" v-if="scope.row.unlockPointAmount">
                      {{ scope.row.unlockPointAmount }}积分
                    </div>
                  </template>
                </el-table-column> -->
              </el-table>
            </div>
          </li>

          <li class="mb20">
            <div class="title">佣金明细</div>
            <!-- detailsBill.shareOrderRelDetailsInfos.records -->

            <el-table
              stripe
              border
              :data="detailsBill.shareOrderRelDetailsInfos.records"
              size="small"
            >
              <el-table-column
                type="index"
                label="序号"
                :index="
                  index =>
                    index + (currentBrokeragePage - 1) * pageBrokerageSize + 1
                "
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="receiptSn"
                label="订单号"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="receiverName"
                label="会员名称"
              >
              </el-table-column>

              <el-table-column
                header-align="center"
                align="center"
                prop="actuallyPrice"
                label="订单金额"
              >
                <template slot-scope="scope" v-if="scope.row.actuallyPrice">
                  <span>¥{{ scope.row.actuallyPrice }}</span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="payTime"
                label="支付时间"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="receiverMobile"
                label="返佣数"
              >
                <template slot-scope="scope">
                  <div class="primary" v-if="scope.row.commissionPrice">
                    货币：¥{{ scope.row.commissionPrice }}
                  </div>
                  <div class="primary" v-if="scope.row.commissionPoint">
                    积分：{{ scope.row.commissionPoint }}
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                header-align="center"
                align="center"
                prop="commissionStatus"
                label="佣金状态"
              >
                <template slot-scope="scope">
                  <span
                    class="success"
                    v-if="scope.row.commissionStatus === 'yes'"
                    >可用</span
                  >
                  <span
                    class="danger"
                    v-if="scope.row.commissionStatus === 'no'"
                    >锁定</span
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="hm-pagination">
              <el-pagination
                background
                :total="detailsBill.shareOrderRelDetailsInfos.total"
                @current-change="pagingBrokerage"
                @size-change="handleSizeChangeBrokerage"
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="currentBrokeragePage"
              ></el-pagination>
            </div>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="dialogVisible = false" size="small" type="primary">
          确认</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="提现详情"
      style="70%"
      :visible.sync="dialogVisibleExtract"
      :before-close="handleClose"
    >
      <div class="content">
        <ul class="info-list">
          <li class="mb20">
            <div class="mb20">
              <el-table stripe border :data="[detailsWithdraw]" size="small">
                <!-- <el-table-column
                  type="index"
                  label="序号"
                  :index="index => index + (goCurrentPage - 1) * goPageSize + 1"
                ></el-table-column> -->
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="memberName"
                  label="姓名"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="memberMobile"
                  label="电话"
                >
                </el-table-column>

                <!-- <el-table-column
                  header-align="center"
                  align="center"
                  prop="totalMoneyProfitAmount"
                  label="总计佣金"
                >
                  <template slot-scope="scope">
                    <span class="primary"
                      >¥{{ scope.row.totalMoneyProfitAmount }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="hasGetcashMoneyAmount"
                  label="已提现佣金"
                >
                  <template slot-scope="scope">
                    <span class="success"
                      >¥{{ scope.row.hasGetcashMoneyAmount }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="unlockMoneyAmount"
                  label="冻结佣金"
                >
                  <template slot-scope="scope">
                    <span>¥{{ scope.row.unlockMoneyAmount }}</span>
                  </template>
                </el-table-column> -->
              </el-table>
            </div>
          </li>

          <li class="mb20">
            <div class="title">提现明细</div>
            <div class="flex flex-end p2011">
              <div>
                <el-date-picker
                  :default-time="['00:00:00', '23:59:59']"
                  class="mr10"
                  size="small"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="distributionDate"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="选择开始日期"
                  end-placeholder="选择结束日期"
                ></el-date-picker>
                <el-button type="primary" size="small" @click="searchExtract"
                  >查询</el-button
                >
              </div>
            </div>
            <el-table
              stripe
              border
              :data="detailsWithdraw.getcashOrders.records"
              size="small"
            >
              <el-table-column
                type="index"
                label="序号"
                :index="index => index + (goCurrentPage - 1) * goPageSize + 1"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="getcashSn"
                label="提现单号"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="receiveAccount"
                label="提现账户"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="getcashTime"
                label="提现日期"
              >
              </el-table-column>

              <el-table-column
                header-align="center"
                align="center"
                prop="returnReceiptSn"
                label="支付流水号"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="getcashCommission"
                label="提现金额"
              >
                <template slot-scope="scope">
                  <span>¥{{ scope.row.getcashCommission }}</span>
                </template>
              </el-table-column>
            </el-table>
            <div class="hm-pagination">
              <el-pagination
                background
                :total="detailsWithdraw.getcashOrders.total"
                @current-change="goPaging"
                @size-change="goHandleSizeChange"
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="goCurrentPage"
              ></el-pagination>
            </div>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button
          @click="
            dialogVisibleExtract = false;
            distributionDate = [];
          "
          size="small"
          type="primary"
        >
          关闭</el-button
        >
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
import { setCookie, getCookie } from "@/utils/utils";
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      commType: "",
      integralBackCommission: "",
      moneyBackCommission: "",
      searchCondition: {},
      commissionMode: "",
      perUnitMoneyExchangePointsRatio: "",
      searchDialogCondition: {},
      currentPage: 1,
      pageSize: 10,
      currentBrokeragePage: 1,
      pageBrokerageSize: 10,
      goCurrentPage: 1,
      goPageSize: 10,
      currentMicroPage: 1,
      pageMicroSize: 10,
      checkedRow: [],
      checkedMicroRow: [],
      show: false,
      dialogVisible: false,
      dialogVisibleExtract: false,
      distributionDate: [],
      dialogVisibleGoods: false,
      categoryFunc: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: 1
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.wxshopCategoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: level + 1,
                wxshopParentCategoryId: data.wxshopCategoryId
              })
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.wxshopCategoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      attributeFunc: {
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level } = node;
          if (level === 0) {
            this.$store.dispatch("queryAttrListByAddGoods").then(res => {
              res.result.forEach(v => {
                v.value = v.valueId;
                v.label = v.attributeValue;
              });
              resolve(res.result);
            });
          } else {
            let params = {};
            if (level === 1) {
              params = {
                typeId: node.data.valueId
              };
            } else {
              params = {
                attributeId: node.data.valueId
              };
            }
            this.$store
              .dispatch("queryAttrListByAddGoods", params)
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.valueId;
                    v.label = v.attributeValue;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      }
    };
  },
  computed: mapGetters([
    "distributionBillList",
    "detailsBill",
    "detailsWithdraw"
  ]),
  watch: {},
  created() {
    this.getParamsCookie();
    this.$store.dispatch("detailsRule").then(res => {
      if (res.result) {
        this.commType = res.result.commissionMode;
        this.queryList();
        this.queryMicroShopGoodsList();
      } else {
        this.$confirm(" 请先设置分销规则", "提示", {
          // cancelButtonText: "取消",
          confirmButtonText: "确定",
          type: "warning"
        })
          .then(() => {
            this.$router.push({
              name: "DistributionRule"
            });
          })
          .catch(() => {
            this.$router.push({
              name: "DistributionRule"
            });
          });
      }
    });
  },
  mounted() {},
  methods: {
    isBatch(val) {
      this.checkedRow.forEach(v => {
        v.commissionMode = val;
      });
    },
    queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      this.setParamsCookie();
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.payTimeStart = this.isArray(searchCondition.date)
        ? searchCondition.date[0]
        : "";

      searchCondition.payTimeEnd = this.isArray(searchCondition.date)
        ? searchCondition.date[1]
        : "";
      // searchCondition.wxshopCategoryId = this.isArray(
      //   searchCondition.wxshopCategoryId
      // )
      //   ? searchCondition.wxshopCategoryId[
      //       searchCondition.wxshopCategoryId.length - 1
      //     ]
      //   : searchCondition.wxshopCategoryId;

      // searchCondition.attributeId = this.isArray(searchCondition.attributeId)
      //   ? searchCondition.attributeId[searchCondition.attributeId.length - 1]
      //   : "";
      Object.assign(params, searchCondition);

      return this.$store.dispatch("distributionBillList", params);
    },
    setParamsCookie() {
      setCookie({
        key: "oldDistributionBillParams",
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({
        key: "oldDistributionBillParams",
        type: "session"
      });
      if (prams) {
        let search = {};
        for (let key in prams) {
          if (key !== "pageSize" && key !== "currentPage") {
            search[key] = prams[key];
          }
        }
        this.searchCondition = search;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },

    queryMicroShopGoodsList() {
      let params = {
        pageSize: this.pageMicroSize,
        pageNo: this.currentMicroPage
      };
      const searchDialogCondition = JSON.parse(
        JSON.stringify(this.searchDialogCondition)
      );
      searchDialogCondition.wxshopCategoryId = this.isArray(
        searchDialogCondition.wxshopCategoryId
      )
        ? searchDialogCondition.wxshopCategoryId[
            searchDialogCondition.wxshopCategoryId.length - 1
          ]
        : searchDialogCondition.wxshopCategoryId;

      searchDialogCondition.attributeId = this.isArray(
        searchDialogCondition.attributeId
      )
        ? searchDialogCondition.attributeId[
            searchDialogCondition.attributeId.length - 1
          ]
        : "";
      Object.assign(params, searchDialogCondition);
      return this.$store.dispatch("queryWxshopList", params);
    },
    sortChange(sort) {
      //   this.sort = sort;
      //   this.queryList();
    },

    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    goPaging(page) {
      this.goCurrentPage = page;
      this.queryWithdrawList();
    },
    pagingBrokerage(page) {
      this.currentBrokeragePage = page;
      this.queryCommissionList();
    },
    handleSizeChangeBrokerage(size) {
      this.currentBrokeragePage = 1;
      this.pageBrokerageSize = size;
      this.queryCommissionList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    goHandleSizeChange(size) {
      this.goCurrentPage = 1;
      this.goPageSize = size;
      this.queryWithdrawList();
    },
    searchExtract() {
      this.goCurrentPage = 1;
      this.queryWithdrawList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    searchGoods() {
      this.currentMicroPage = 1;
      this.queryMicroShopGoodsList();
    },

    getMicroChecked(selection) {
      this.checkedMicroRow = selection;
    },
    getChecked(selection) {
      this.checkedRow = selection;
    },

    toDetails(row) {
      this.dialogVisible = true;
      this.shareCenterId = row.shareCenterId;
      this.queryCommissionList();
    },
    queryCommissionList() {
      let params = {
        pageSize: this.pageBrokerageSize,
        pageNo: this.currentBrokeragePage,
        shareCenterId: this.shareCenterId
      };
      return this.$store.dispatch("detailsBill", params);
    },
    edit(row) {
      this.dialogVisibleExtract = true;
      this.shareCenterId = row.shareCenterId;
      this.queryWithdrawList();
    },
    queryWithdrawList() {
      let params = {
        pageSize: this.goPageSize,
        pageNo: this.goCurrentPage,
        shareCenterId: this.shareCenterId,
        getcashApprovalState: "pay"
      };
      params.startGetcashTime = this.isArray(this.distributionDate)
        ? this.distributionDate[0]
        : "";
      params.endGetcashTime = this.isArray(this.distributionDate)
        ? this.distributionDate[1]
        : "";

      return this.$store.dispatch("detailsWithdraw", params);
    },
    handleClose(done) {
      this.distributionDate = [];
      done();
    },
    // batchAffirm() {
    //   // this.checkedRow.map(v => {
    //   // });
    //   let params = {};
    //   params.skuInfoBos = this.checkedRow;
    //   params.integralBackCommission = this.integralBackCommission;
    //   params.moneyBackCommission = this.moneyBackCommission;
    //   params.perUnitMoneyExchangePointsRatio = this.perUnitMoneyExchangePointsRatio;

    //   this.$store.dispatch("editBatchRelInfo", params).then(res => {
    //     if (res.code === "0") {
    //       this.dialogVisible = false;
    //       this.queryList();
    //     }
    //   });
    // },
    goAddgoods() {},
    goRemove(index, rows) {
      rows.splice(index, 1);
    },
    gotoRule() {
      this.$router.push({
        name: "DistributionRule"
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.micro-goods-list {
  .el-tabs__header {
    background: #f4f4f4;
  }
}
.el-table .warningRow {
  background: rgba(255, 240, 240, 1);
  border: 1px solid rgba(255, 0, 0, 1);
}
.content {
  .el-step.is-center .el-step__description {
    padding: 0;
  }
}
</style>
<style scoped lang="scss">
.table-panel {
  font-size: 12px;
  .line {
    color: #dcdfe6;
    margin: 0 5px;
  }
}
.batch {
  div {
    margin: 20px 0;
    cursor: pointer;
    font-size: 14px;
    color: #222222;
    user-select: none;
    &:first-child {
      margin-right: 20px;
    }
  }
  .hmicon {
    margin-right: 5px;
  }
}
.p2011 {
  padding: 0 0 10px 0;
}
.tabs {
  .first-tip {
    padding-left: 30px;
    margin-bottom: 20px;
    .title {
      padding-left: 0;
    }
  }
  .title {
    color: #222222;
    padding-left: 10px;
  }
  .form-item-tip {
    font-size: 12px;
  }
}
.form-item-tip {
  color: #999;
  font-size: 14px;
}

.content {
  margin: -20px;
  .progress {
    background: #f7f7f7;
    padding: 20px 0;
  }
}
.info-list {
  padding: 0 20px;
}
.info-list,
.logistics-list {
  .title {
    // margin-bottom: 20px;
    &::before {
      display: inline-block;
      margin-right: 10px;
      content: "";
      width: 4px;
      height: 12px;
      background: #e50065;
      border-top-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
}

.content-item {
  line-height: 25px;
  color: #222;
  .info {
    color: #666666;
  }
}
</style>
